import axios from 'axios';

let prefix = "/stakeholder-portal"

const StakeholderPortalApi = {

	// Customer-facing portal (roles 5/6). Backend scopes the payload to the
	// authenticated stakeholder — scope:'location' for owners, scope:'evse' for investors.
	getPortalOverview(payload){
		return axios.get( prefix + "/overview", {params: payload})
	},
}

export default StakeholderPortalApi;
